import { ADMIN_DIVISION_URL } from 'src/config/api.config';
import ApiService from './Api.service';

class AdminDivisionService extends ApiService {
  constructor() {
    super(ADMIN_DIVISION_URL);
  }
  getByUrlId = (id) => {
    return this.doGet(`${ADMIN_DIVISION_URL}/${id}`, {}, { ...this._headers });
  };
}

export default new AdminDivisionService();
